import z from 'zod';
import { textTranslatableSchema } from '@app/schemas/text';
import { imageSchema, imageTranslatableSchema } from '@app/schemas/image';
import { languageSchema } from '@app/schemas/language';

const promptTextSchema = textTranslatableSchema.extend({
  translations: z.record(languageSchema, z.string().max(500, { message: 'Text is too long' })),
}).superRefine((text, context) => {
  if (typeof text.translations[text.fallback] !== 'string') {
    context.addIssue({ code: 'custom', path: ['translations', text.fallback], message: 'Add the fallback language translation.' });
  }
});

const gifImageSchema = imageSchema.extend({
  uri: z.string().max(2048).regex(/^file:\/\/\d+$/, 'Choose a GIF file from the media library.'),
});

const gifTranslatableSchema = imageTranslatableSchema.extend({
  translations: z.record(languageSchema, gifImageSchema),
}).superRefine((image, context) => {
  if (!image.translations[image.fallback]) {
    context.addIssue({ code: 'custom', path: ['translations', image.fallback, 'uri'], message: 'Choose a GIF in the fallback language.' });
  }
});

export const interactionPromptIndicatorSchema = z.discriminatedUnion('type', [
  z.strictObject({ type: z.literal('none') }),
  z.strictObject({ type: z.literal('default') }),
  z.strictObject({ type: z.literal('gif'), image: gifTranslatableSchema }),
]);

export const interactionPromptSchema = z.strictObject({
  text: promptTextSchema.optional(),
  touchIndicator: interactionPromptIndicatorSchema.optional(),
  repeatDelay: z.number().min(0).max(3600).optional(),
});

export type InteractionPromptSchema = z.infer<typeof interactionPromptSchema>;

z.globalRegistry.add(interactionPromptIndicatorSchema, { id: 'interaction-prompt-indicator' });
z.globalRegistry.add(interactionPromptSchema, { id: 'interaction-prompt' });
